import _ from 'lodash';

import { IUser, IUserPermissions } from '../store/UserSlice';

export const checkUserPermission = (
  authUser: IUser | undefined,
  permissions: IUserPermissions
): boolean => {
  let hasPermission = false;
  if (authUser && authUser.role && authUser.role.permissions) {
    _.map(permissions, (permission, module) => {
      if (
        authUser.role.permissions[module] &&
        _.intersection(authUser.role.permissions[module], permission).length > 0
      ) {
        hasPermission = true;
      }
    });
  }
  return hasPermission;
};

export const checkIsUser = (authUser: IUser | undefined): boolean => {
  if (
    authUser &&
    authUser.role &&
    (authUser.role.name === 'Student' ||
      authUser.role.name === 'Tutor' ||
      authUser.role.name === 'Guest')
  ) {
    return true;
  }
  return false;
};

export const test = '';
